<template>
    <v-container
        fluid
        class="pb-0"
        style="background-color: #f4f4f4 !important; border-radius: 12px"
    >
        <v-row class="mt-0 ml-1 mb-0 pb-0">
            <v-col
                cols="6"
                class="py-2 hide-scrollbar"
                style="height: calc(97vh - 140px); overflow-y: auto"
            >
                <InvoiceHtmlTemplateView
                    :invoiceThemeSettings="updatedSettings"
                    :invoiceData="invoiceSample"
                    :quotation="quotationSample"
                    :forPrint="false"
                    :company="company"
                    :backgroundImage="backgroundImage"
                    :additionalDocument="additionalDocument"
                    :additionalDocumentId="additionalDocumentId"
                    :editedElementClass="editedElementClass"
                />
            </v-col>
            <v-col cols="6" class="py-0">
                <div
                    class="rounded-xl hide-scrollbar"
                    style="height: calc(97vh - 140px); overflow-y: auto; background: white"
                >
                    <InvoiceThemeMenu
                        :companyId="companyId"
                        :initialInvoiceThemeSettings="invoiceThemeSettings"
                        :idTheme="idTheme"
                        @upsert-invoice-theme="upsertInvoiceTheme"
                        @pdf-preview="onPDFPreview()"
                        @background-image="(imageData) => handleImageBackground(imageData)"
                        @additional-document="(docData) => handleAdditionalDocument(docData)"
                        @editing="editing($event)"
                        @theme-selected="handleThemeSelected($event)"
                        @reset-personalized="handlePersonalizedThemeReset"
                        @document-type-selected="handleDOcumentTypeSelected($event)"
                        @settings-change="handleSettingsChange"
                        @changed-legal-form-info="onLegalFormInfoChanged"
                    >
                    </InvoiceThemeMenu>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import InvoiceThemeMenu from "./InvoiceThemeMenu.vue";
import { Apollo } from "@/decorators";
import moment from "moment";
import { User } from "../../store/store";

import INVOICE_THEMES from "../../graphql/invoiceTheme/InvoiceThemes.gql";
import UPSERT_INVOICE_THEME from "../../graphql/invoiceTheme/UpsertInvoiceTheme.gql";
import DELETE_INVOICE_THEME from "../../graphql/invoiceTheme/DeleteInvoiceTheme.gql";
import GET_INVOICE_THEME_BACKGROUND from "@/graphql/invoiceTheme/GetInvoiceThemeBackground.gql";
import GET_INVOICE_ADDITIONAL_DOCUMENT from "@/graphql/invoiceTheme/GetInvoiceThemeAdditionalDocument.gql";

// import Logo from "../configuration/Logo.vue"
import { defaultLegalForm } from "../../services/companyServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import InvoiceHtmlTemplateView from "./InvoiceHtmlTemplateView.vue";
import InvoiceHtmlViewService from "../../../../backend/src/common/invoiceTheme/InvoiceHtmlBuilder";
import InvoiceThemeService from "../../../../backend/src/common/invoiceTheme/invoiceThemeService";
import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices";
import * as _ from "lodash";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        InvoiceThemeMenu,
        InvoiceHtmlTemplateView,
    },
})
export class InvoiceThemeEdition extends Vue {
    @Prop({ default: null }) companyId: string;

    companyPropToShow = [];

    conditionsList = [];

    // personalisedInvoiceThemeSettings = {}

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }

    defaultTableColumns = InvoiceThemeService.getDefaultTableColumns();

    // defaultVATTableColumns =  InvoiceThemeService.getDefaultVATTableColumns()

    // defaultInvoiceThemeSettings = InvoiceThemeService.getDefaultInvoiceThemeSettings()
    defaultInvoiceThemeSettings = InvoiceThemeService.originalTheme(); //InvoiceThemeService.bobbeeDefaultTheme()

    backgroundImage = null;
    additionalDocument = null;
    additionalDocumentId = null;
    editedElementClass = null;

    // @Watch('editedElementClass')
    // watcher() {
    //     console.log("Watching editedElementClass", this.editedElementClass)
    // }

    paymentDetails: string = "";

    onLegalFormInfoChanged(value: {
        companyId?: string;
        paymentDetails?: string;
        legalNotices?: string;
        paymentMode?: string;
    }) {
        // debugger;
        this.paymentDetails = value.paymentDetails;
        if (this.company) {
            this.company.invoiceTextPaymentDetails = value.paymentDetails;
            this.company.invoiceTextLegalNotices = value.legalNotices;
            this.company.invoiceTextPaymentMode = value.paymentMode;
        }
    }

    editing(editedElementClass) {
        this.editedElementClass = editedElementClass;
    }

    updatedSettings_: any = "";

    get updatedSettings() {
        return this.updatedSettings_ || this.invoiceThemeSettings;
    }

    set updatedSettings(newVal) {
        this.updatedSettings_ = _.merge({}, newVal);
    }

    handleSettingsChange(settings) {
        this.updatedSettings = settings;
    }

    invoiceTemplate = {
        emitter: {
            name: "Nom émetteur",
            address: "Adresse émetteur",
            siret: "Siret émetteur",
            ape: "APE émetteur", // Code NAF, activité principale de l'entreprise
            logo: "Logo émetteur",
            email: this.currentUser?.email || "mail.user@exemple.com",
            phone: "06 01 01 20 01",
        },
        receiver: {
            name: "Nom destinataire",
            address: "Adresse destinataire",
            siret: "Siret destinataire",
            ape: "APE destinataire",
            logo: "Logo destinataire",
            email: "destinataire@exemple.com",
        },
        // miscellaneous:{
        //     bobbee:"bobbee",
        //     pagination:"Pagination",
        //     title:"Titre du document",
        // }
    };

    invoiceTableTemplate = {
        title: "Ma Facture",
        name: "Facture Numéro 000000",
        date: moment().format("DD/MM/YYYY"),
        dueDate: moment().add(3, "days").format("DD/MM/YYYY"),
        rows: [
            {
                product: "Produit 1",
                description: "Description 1",
                quantity: "1",
                unitPrice: "100",
                vat: "20%",
                netAmount: "120",
            },
            {
                product: "Produit 2",
                description: "Description 2",
                quantity: "1",
                unitPrice: "100",
                vat: "20%",
                netAmount: "120",
            },
            {
                product: "Produit 3",
                description: "Description 3",
                quantity: "1",
                unitPrice: "100",
                vat: "10%",
                netAmount: "120",
            },
        ],
        total_netAmount: "300,00 €",
        total_vatAmount: "50,00 €",
        total_grossAmount: "350,00 €",
    };

    invoiceVATTableData = {
        rows: [
            {
                netAmount: 200,
                vatRate: "20%",
                vatAmount: 40,
            },
            {
                netAmount: 100,
                vatRate: "10%",
                vatAmount: 10,
            },
        ],
        total_netAmount: "300,00 €",
        total_vatAmount: "50,00 €",
        total_grossAmount: "350,00 €",
    };

    // invoiceSample = {
    //     "__typename": "Invoice",
    //     "id": "",
    //     "type": "INVOICE",
    //     "title": "Facturation AWS de juin 2024",
    //     "additionalComment": null,
    //     "internalComment": null,
    //     "number": "FACTURE-203409-0000074",
    //     "receivers": null,
    //     "status": "VALIDATED",
    //     "date": "2024-07-08T00:00:00.000Z",
    //     "dueDate": "2024-08-08T00:00:00.000Z",
    //     "paymentTerms": null,
    //     "paymentDetails": null,
    //     "periodicity": null,
    //     "nextDate": null,
    //     "startDate": null,
    //     "vatType": "NO_VAT_TYPE",
    //     "endDate": null,
    //     "dueDateUnitOfTime": null,
    //     "dueDateAmount": null,
    //     "legalText": null,
    //     "creditNoteOf": null,
    //     "creditNotes": [],
    //     "company": {
    //         "__typename": "Company",
    //         "id": "ck93umltabtuf0730wifcojfb",
    //         "name": "Pixello Agency",
    //         "address": "91 RUE DU DOCTEUR SUREAU",
    //         "postalCode": "93160",
    //         "city": "NOISY LE GRAND",
    //         "country": "France",
    //         "siret": "07955603100015",
    //         "siren": "079556031",
    //         "vatNumber": "FR90079556031"
    //     },
    //     "client": {
    //         "__typename": "Company",
    //         "id": "",
    //         "name": "Société cliente",
    //         "address": "14 RUE DES JEUNEURS",
    //         "postalCode": "75002",
    //         "city": "Paris",
    //         "country": "France",
    //         "siret": "XXXXXXXXXXXXXXXX",
    //         "siren": null,
    //         "vatNumber": null,
    //         "isActive": true
    //     },
    //     "lines": [
    //         {
    //             "__typename": "InvoiceLine",
    //             "id": "clyy8o7z5000ce0jcv9yu8ozf",
    //             "type": "PRODUCT",
    //             "reference": "blabla",
    //             "title": "blabla",
    //             "description": "",
    //             "quantity": 1,
    //             "unitPrice": 100,
    //             "netAmount": 100,
    //             "grossAmount": 105.5,
    //             "vatAmount": 5.5,
    //             "vatRate": 5.5,
    //             "discount": null,
    //             "discountPercentage": null,
    //             "product": {
    //                 "__typename": "InvoiceProduct",
    //                 "id": "ckpweg23oeiup0842jt41fjmr",
    //                 "description": null,
    //                 "percentage": null,
    //                 "accountableAccount": null
    //             },
    //             "expand": false,
    //             "discountType": "%"
    //         },
    //         {
    //             "__typename": "InvoiceLine",
    //             "id": "clyy8o7z5000de0jcfzyefyie",
    //             "type": "PRODUCT",
    //             "reference": "PA-100-4",
    //             "title": "PA 100 4",
    //             "description": "",
    //             "quantity": 1,
    //             "unitPrice": 4,
    //             "netAmount": 4,
    //             "grossAmount": 4.8,
    //             "vatAmount": 0.8,
    //             "vatRate": 20,
    //             "discount": null,
    //             "discountPercentage": null,
    //             "product": {
    //                 "__typename": "InvoiceProduct",
    //                 "id": "ck9827htaum9c07303m2ndi39",
    //                 "description": null,
    //                 "percentage": null,
    //                 "accountableAccount": null
    //             },
    //             "expand": false,
    //             "discountType": "%"
    //         },
    //         {
    //             "__typename": "InvoiceLine",
    //             "id": "clyy8o7z6000ee0jc938ydb05",
    //             "type": "PRODUCT",
    //             "reference": "t1",
    //             "title": "testMax",
    //             "description": "test",
    //             "quantity": 1,
    //             "unitPrice": 10,
    //             "netAmount": 10,
    //             "grossAmount": 10.21,
    //             "vatAmount": 0.21,
    //             "vatRate": 2.1,
    //             "discount": null,
    //             "discountPercentage": null,
    //             "product": {
    //                 "__typename": "InvoiceProduct",
    //                 "id": "clu752jz00001ue6w9j6i8yib",
    //                 "description": "test",
    //                 "percentage": null,
    //                 "accountableAccount": {
    //                     "__typename": "AccountableAccount",
    //                     "id": "clrcb6kgk007psmj8yltiltla",
    //                     "name": "706"
    //                 }
    //             },
    //             "expand": true,
    //             "discountType": "%"
    //         },
    //         {
    //             "__typename": "InvoiceLine",
    //             "id": "clyy8o7z6000fe0jch1sw3bzi",
    //             "type": "PRODUCT",
    //             "reference": "t2",
    //             "title": "test87",
    //             "description": "er",
    //             "quantity": 4,
    //             "unitPrice": 100,
    //             "netAmount": 400,
    //             "grossAmount": 480,
    //             "vatAmount": 80,
    //             "vatRate": 20,
    //             "discount": null,
    //             "discountPercentage": null,
    //             "product": {
    //                 "__typename": "InvoiceProduct",
    //                 "id": "clu7536od0002ue6wenk1hcdt",
    //                 "description": "er",
    //                 "percentage": null,
    //                 "accountableAccount": {
    //                     "__typename": "AccountableAccount",
    //                     "id": "clrcb6kgk007psmj8yltiltla",
    //                     "name": "706"
    //                 }
    //             },
    //             "expand": true,
    //             "discountType": "%"
    //         },
    //         {
    //             "__typename": "InvoiceLine",
    //             "id": "clyy8o7z6000ge0jcbbxzr11m",
    //             "type": "PRODUCT",
    //             "reference": "1245789B87A6C5432F13ZA4D567F5",
    //             "title": "Banane",
    //             "description": "",
    //             "quantity": 3,
    //             "unitPrice": 2,
    //             "netAmount": 6,
    //             "grossAmount": 6,
    //             "vatAmount": 0,
    //             "vatRate": 0,
    //             "discount": null,
    //             "discountPercentage": null,
    //             "product": {
    //                 "__typename": "InvoiceProduct",
    //                 "id": "clxsyagpc00wjfjyp5dpbo23w",
    //                 "description": "",
    //                 "percentage": null,
    //                 "accountableAccount": {
    //                     "__typename": "AccountableAccount",
    //                     "id": "clrcb6kgk007psmj8yltiltla",
    //                     "name": "706"
    //                 }
    //             },
    //             "expand": false,
    //             "discountType": "%"
    //         }
    //     ],
    //     "document": {
    //         "__typename": "Document",
    //         "id": "clyy8moe50000pkttkrchwvlr"
    //     },
    //     "signedUrl": "https://staging-bobbeeinfra-oss360-user-data-eu-west-3.s3.eu-west-3.amazonaws.com/companies/ck93umltabtuf0730wifcojfb/documents/dc60d1e277f75f72dcea653e7d2a2855?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA2IMI7CFJARNWGLTY%2F20240726%2Feu-west-3%2Fs3%2Faws4_request&X-Amz-Date=20240726T084824Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJHMEUCIQDoDZmTPDKBfgWujNXRSpqi84gJjSE7XCxf%2F8LCHBGAtgIgG0R2RqFk7DUKiTYjN8dHT%2FzSBMlh2poaa%2FRHmwDguuoqhQMI0f%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw3MDUxOTg3NTYxNzgiDIZN5%2BrGPMCOnjkHpCrZAjyTe2v%2BmZ6Ju2NLroEzhsGdtLI4yCaK%2BsgYef8wjyMltLpo0qUiOLR%2Fffed8vbrsmDmVBLN%2FkH2FQPmBw8a1p0ssbZJldvuj0jCXqIAjMky86B9FAlFwhrjz21uoNQqy4yr737qWOTjQlYRHeGOUVg8PsKThv4nXQ1ABF23%2FkRnwbJuRx%2BxkQTVMIfCQYMKqY99u3CYQ8WsXPXv2oIV7z7abDHewfCIJE5u9fEQozV7zFBbCjfanD16z7BYC4%2Bql9QcxvVs44Y1pwua34BAw%2FhU5Hz1hWyq6n9HEQfWS%2F6sTviZqmjKa2oAOT6uZuoWPxlzorcSRA7%2B%2BJqOocgtizIyjwsgC6QWDmwmk4XCmnh7NByN7F0s4XDdmJpOY53T8y5y1P94d6PhBUVLvJmROHSmZU2ky0ynCDl6NAwKAfX3Icc4w4tURCamWb%2F4Ex7TJ8FUqZyLMok6oDDNs421BjqnAewVGdTgJrh3YYw%2FCoKswtfq05yZ4xxpYVjFCN78LynRhYm1w52pveBzM7%2FlKLikoUTwUZXNmp4zpL8WdL1OFYy6yMlcj0B6Y6Gt37WvV34zYcMRQqa1JTcxqb3E5cRJBCLK04An31HNr9hkgVd27uF6u%2F9YiIujuq8w3PwnZkKXNOsv%2F4dw4Msxni2uKCZi46gzNdDBGQNOmcwh0f2weTiJd%2FxG3lpU&X-Amz-Signature=ae88d37003b2d87fd4716683bdd21e0167e6d12423c10e521709b65257a7cdbc&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%20%3D%22Pixello%20Agency-FACTURE-202407-0000052-THE%20BBQ%20BROTHERS.pdf%22&x-id=GetObject",
    //     "autoValidation": null,
    //     "sendEmailAfterValidation": null,
    //     "data": {
    //         "legalText": "Pixello Agency au capital social de 1000 € - 91 RUE DU DOCTEUR SUREAU 93160 NOISY LE GRAND - RCS AGEN 841097223 - APE 6201Z - TVA Intracommunautaire FR29841097223",
    //         "paymentDetails": "Le règlement anticipé ne donne pas lieu à escompte. En cas de règlement tardif, il sera appliqué un intérêt égal à 3 fois le taux légal.\n\nOutre des pénalités de retard déjà prévues par la loi, une indemnité forfaitaire pour frais de recouvrement de 40 euros sera appliquée.",
    //         "additionalComment": "",
    //         "internalComment": "",
    //         "receivers": [
    //             {
    //                 "email": "",
    //                 "lastname": "",
    //                 "firstname": "",
    //                 "phoneNumber": ""
    //             }
    //         ],
    //         "deposits": [
    //             {
    //                 "date": "2024-07-08T00:00:00.000Z",
    //                 "name": "Acompte 1 de la {{FACTURE-PROVISOIRE}}",
    //                 "amount": 303.26,
    //                 "percentage": 50
    //             },
    //             {
    //                 "date": "2024-08-08T02:00:00+02:00",
    //                 "name": "Acompte 2 de la {{FACTURE-PROVISOIRE}}",
    //                 "amount": 303.25,
    //                 "percentage": 50
    //             }
    //         ]
    //     },
    //     "depositOf": null,
    //     "deposits": [
    //         {
    //             "__typename": "Invoice",
    //             "id": "clyy8mecy0007e0jcqc9d4fxv",
    //             "title": "Acompte 1 de la FACTURE-202407-0000052",
    //             "date": "2024-07-08T00:00:00.000Z",
    //             "status": "VALIDATED",
    //             "grossAmount": 303.26
    //         },
    //         {
    //             "__typename": "Invoice",
    //             "id": "clyy8medc000ae0jc2shu6x25",
    //             "title": "Acompte 2 de la FACTURE-202407-0000052",
    //             "date": "2024-08-08T00:00:00.000Z",
    //             "status": "VALIDATED",
    //             "grossAmount": 303.25
    //         }
    //     ],
    //     "discount": null,
    //     "discountPercentage": null,
    //     "tags": []
    // }

    selectedDocumentType = "Facture";

    /**
     * Preview sample
     */
    get invoiceSample() {
        if (!this.selectedDocumentType) {
            return {};
        }
        const inv = _.cloneDeep(
            InvoiceThemeFrontService.getSampleInvoiceAndQuotation(this.selectedDocumentType)
                ?.invoice ?? {},
        );
        if (this.company) {
            // Replace sample company with current company
            inv.company = this.company;
        }
        if (!inv.data) {
            inv.data = {};
        }
        inv.data.paymentDetails = this.paymentDetails;
        return inv;
    }

    get quotationSample() {
        if (!this.selectedDocumentType) {
            return {};
        }
        const quot =
            InvoiceThemeFrontService.getSampleInvoiceAndQuotation(this.selectedDocumentType)
                ?.quotation ?? {};
        if (this.company) {
            // Replace sample company with current company
            quot.company = this.company;
        }
        return quot;
    }

    @Apollo({
        query: gql`
            query company($companyId: ID!) {
                company(where: { id: $companyId }) {
                    id
                    invoiceTextPaymentDetails
                    invoiceTextLegalNotices
                    invoiceTextPaymentMode
                    name
                    siren
                    siret
                    vatNumber
                    legalForm
                    shareCapital
                    registrationTown
                    logo {
                        id
                        key
                        signedUrl
                    }
                    activities {
                        id
                        name
                        description
                    }
                    address
                    postalCode
                    city
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data && data.company) {
                const company = data.company;
                // if (this.company.invoiceTextPaymentDetails === null) {
                //     this.company.invoiceTextPaymentDetails = this.$t("invoice.paymentDetails");
                // }
                if (!this.company.invoiceTextLegalNotices) {
                    this.company.invoiceTextLegalNotices = this.defaultLegalForm;
                }
                this.company = company;
            } else {
                this.company = {
                    id: "",
                    invoiceTextPaymentDetails: "",
                    invoiceTextLegalNotices: "",
                    invoiceTextPaymentMode: "",
                    name: "",
                    siren: "",
                    vatNumber: "",
                    shareCapital: 0,
                    registrationTown: "",
                    activities: [],
                    logo: {
                        signedUrl: "",
                    },
                    address: "",
                    postalCode: "",
                    city: "",
                };
            }
        },
    })
    company = {
        id: "",
        invoiceTextPaymentDetails: "",
        invoiceTextLegalNotices: "",
        invoiceTextPaymentMode: "",
        name: "",
        siren: "",
        siret: "",
        vatNumber: "",
        shareCapital: 0,
        registrationTown: "",
        logo: {
            signedUrl: "",
        },
        activities: [],
        address: "",
        postalCode: "",
        city: "",
    };

    @Apollo({
        query: INVOICE_THEMES,
        variables() {
            return {
                company: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        async specificResult({ data, loading }: any) {
            if (!loading) {
                if (
                    data?.invoiceThemes?.length &&
                    data.invoiceThemes[0].id &&
                    data.invoiceThemes[0].theme
                ) {
                    this.personalisedInvoiceThemeSettings =
                        InvoiceThemeService.mergeWithDefaultSettings(data.invoiceThemes[0].theme);

                    this.idTheme = data.invoiceThemes[0].id;
                    if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
                        if (data.invoiceThemes[0].background?.signedUrl) {
                            this.backgroundImage = data.invoiceThemes[0].background.signedUrl;
                        } else {
                            await this.fetchBackgroundImage();
                        }
                    } else {
                        this.backgroundImage = (
                            await InvoiceThemeFrontService.fetchDefaultBackground(
                                this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
                            )
                        )?.signedUrl;
                    }

                    if (data.invoiceThemes[0].additionalDocument?.signedUrl) {
                        this.additionalDocument =
                            data.invoiceThemes[0].additionalDocument.signedUrl;
                        this.additionalDocumentId = data.invoiceThemes[0].additionalDocument.fileId;
                    } else {
                        await this.fetchAdditionalDocument();
                    }
                }
            }
        },
    })
    personalisedInvoiceThemeSettings = JSON.parse(JSON.stringify(this.defaultInvoiceThemeSettings));

    async refetchPersonalizedTheme() {
        if (this.companyId) {
            const response = await this.$apollo.query({
                query: INVOICE_THEMES,
                variables: {
                    company: this.companyId,
                },
            });

            if (
                response?.data?.invoiceThemes?.length &&
                response.data.invoiceThemes[0].id &&
                response.data.invoiceThemes[0].theme
            ) {
                const data = response.data;

                this.personalisedInvoiceThemeSettings =
                    InvoiceThemeService.mergeWithDefaultSettings(data.invoiceThemes[0].theme);

                this.idTheme = data.invoiceThemes[0].id;
                if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
                    // Only set personnalized background when a default background is not selected
                    if (data.invoiceThemes[0].background?.signedUrl) {
                        this.backgroundImage = data.invoiceThemes[0].background.signedUrl;
                    } else {
                        await this.fetchBackgroundImage();
                    }
                } else {
                    this.backgroundImage = (
                        await InvoiceThemeFrontService.fetchDefaultBackground(
                            this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
                        )
                    )?.signedUrl;
                }

                if (data.invoiceThemes[0].additionalDocument?.signedUrl) {
                    this.additionalDocument = data.invoiceThemes[0].additionalDocument.signedUrl;
                    this.additionalDocumentId = data.invoiceThemes[0].additionalDocument.fileId;
                } else {
                    await this.fetchAdditionalDocument();
                }
            } else {
                this.personalisedInvoiceThemeSettings = JSON.parse(
                    JSON.stringify(this.defaultInvoiceThemeSettings),
                );
            }
        }
    }

    idTheme = "";

    async fetchBackgroundImage() {
        if (this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
            // A default background is selected. Don't fetch
            return;
        }

        if (!this.idTheme || this.idTheme.length === 0) {
            this.backgroundImage = null;
            return;
        }

        const response = await this.$apollo.query({
            query: GET_INVOICE_THEME_BACKGROUND,
            variables: {
                id: this.idTheme,
            },
        });

        if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
            // Only set when a default background is not selected

            if (!response?.data?.getInvoiceThemeBackground?.signedUrl) {
                // debugger
                this.backgroundImage = null;
                return;
            }
            this.backgroundImage = response.data.getInvoiceThemeBackground.signedUrl;
        }
    }

    async fetchAdditionalDocument() {
        if (!this.idTheme || this.idTheme.length === 0) {
            this.additionalDocument = null;
            this.additionalDocumentId = null;
            return;
        }

        const response = await this.$apollo.query({
            query: GET_INVOICE_ADDITIONAL_DOCUMENT,
            variables: {
                id: this.idTheme,
            },
        });

        if (!response?.data?.getInvoiceThemeAdditionalDocument?.signedUrl) {
            // debugger
            this.additionalDocument = null;
            this.additionalDocumentId = null;
            return;
        }
        this.additionalDocument = response.data.getInvoiceThemeAdditionalDocument.signedUrl;
        this.additionalDocumentId = response.data.getInvoiceThemeAdditionalDocument.fileId;
    }

    async upsertInvoiceTheme(optionalCallback = null) {
        // debugger

        // if(this.useBobbeeInvoiceThemeDefault && this.idTheme) {
        //     await this.$apollo.mutate({
        //         mutation: DELETE_INVOICE_THEME,
        //         variables: {
        //             id: this.idTheme
        //         }
        //     })
        //     this.idTheme = ""
        // }

        if (this.updatedSettings) {
            this.updatedSettings.name = "Personal"; // Theme settings name
            const result = await this.$apollo.mutate({
                mutation: UPSERT_INVOICE_THEME,
                variables: {
                    id: this.idTheme,
                    createCompany: { connect: { id: this.companyId } },
                    updateCompany: { connect: { id: this.companyId } },
                    theme: this.updatedSettings,
                },
            });
            this.idTheme = result.data.upsertInvoiceTheme.id;
            if (optionalCallback) {
                await optionalCallback(this.idTheme);
            }
            this.personalisedInvoiceThemeSettings = JSON.parse(
                JSON.stringify(this.updatedSettings),
            );
        }
    }

    // get companyId() {
    //     if (this.$route.params.id) {
    //         return this.$route.params.id;
    //     } else if (this.$route.params.companyId) {
    //         return this.$route.params.companyId
    //     }
    //     return ""
    // }

    get invoiceThemeSettings() {
        return this.personalisedInvoiceThemeSettings;
    }

    get name() {
        let regEx = "";
        if (this.conditionsList.length) {
            if (this.conditionsList[0].siren) {
                regEx += this.conditionsList.length.toString() + " Siren(s) : ";
                regEx +=
                    this.companyPropToShow.slice(0, 2).join(", ") +
                    (this.companyPropToShow.length > 2 ? ", ..." : "");
            } else if (this.conditionsList[0].id) {
                regEx += this.conditionsList.length.toString() + " Société(s) : ";
                if (this.companyPropToShow.slice(0, 2).join(", ").length < 35) {
                    regEx +=
                        this.companyPropToShow.slice(0, 2).join(", ") +
                        (this.companyPropToShow.length > 2 ? ", ..." : "");
                } else {
                    regEx +=
                        this.companyPropToShow[0] +
                        (this.companyPropToShow.length > 1 ? ", ..." : "");
                }
            }
        }
        return regEx;
    }

    get legalForm() {
        if (this.company?.invoiceTextLegalNotices) {
            return this.company.invoiceTextLegalNotices;
        }
        return defaultLegalForm(this.company);
    }

    get paymentTerms() {
        return this.company.invoiceTextPaymentDetails || "";
    }

    // topPageStyle() {

    //     if (this.invoiceThemeSettings?.style?.backgroundColor) {

    //         return {
    //             // "margin": "20px",
    //             // "padding-right":"10px",
    //             "background-color": 'FFFFFF', //this.invoiceThemeSettings?.style?.backgroundColor ? this.invoiceThemeSettings?.style?.backgroundColor : "",
    //             "min-height":"150px"
    //         }
    //     }

    //     return {
    //         // "margin": "20px",
    //         // "padding-right":"10px",
    //         "background-color": "#ffffff",
    //         "min-height": "150px",
    //     }
    // }

    // receiverStyle() {
    //     if (this.invoiceThemeSettings?.receiver?.style) {
    //         return {
    //             border: this.invoiceThemeSettings?.receiver?.style?.border ? "1px solid black" : "0px",
    //             "background-color": this.invoiceThemeSettings?.receiver?.style?.backgroundColor ? this.invoiceThemeSettings?.receiver?.style?.backgroundColor : "",
    //             "border-color": this.invoiceThemeSettings?.receiver?.style?.borderColor ? this.invoiceThemeSettings?.receiver?.style?.borderColor : "",
    //             "font-size":"10px",
    //             "font-weight": this.invoiceThemeSettings?.receiver?.style?.fontWeight ? this.invoiceThemeSettings?.firstPage?.receiver?.style?.fontWeight : "",
    //             "font-family": this.invoiceThemeSettings?.receiver?.style?.fontFamily ? this.invoiceThemeSettings?.receiver?.style?.fontFamily : "",
    //             "color": this.invoiceThemeSettings.receiver?.style?.backgroundColor ? this.getAutomaticTextColor(this.invoiceThemeSettings.receiver.style.backgroundColor) : '',
    //             "text-align": "left",
    //         }
    //     }
    //     return ""
    // }
    // get receiverVColStyle() {
    //     if(this.invoiceThemeSettings?.receiver?.style?.textPosition) {
    //         if(this.invoiceThemeSettings.receiver.style.textPosition === "left") {
    //             return "px-2 d-flex justify-start"
    //         }
    //         if(this.invoiceThemeSettings.receiver.style.textPosition === "center") {
    //             return "px-2 d-flex justify-center"
    //         }
    //     }
    //     return "px-2 d-flex justify-end"
    // }

    // emitterStyle() {
    //     if (this.invoiceThemeSettings?.emitter?.style) {
    //         return {
    //             border: this.invoiceThemeSettings?.emitter?.style?.border ? "1px solid black" : "0px",
    //             "background-color": this.invoiceThemeSettings?.emitter?.style?.backgroundColor ? this.invoiceThemeSettings?.emitter?.style?.backgroundColor : "",
    //             "border-color": this.invoiceThemeSettings?.emitter?.style?.borderColor ? this.invoiceThemeSettings?.emitter?.style?.borderColor : "",
    //             "font-size":"10px",
    //             "font-weight": this.invoiceThemeSettings?.emitter?.style?.fontWeight ? this.invoiceThemeSettings?.emitter?.style?.fontWeight : "",
    //             "font-family": this.invoiceThemeSettings?.emitter?.style?.fontFamily ? this.invoiceThemeSettings?.emitter?.style?.fontFamily : "",
    //             "color": this.invoiceThemeSettings?.emitter?.style?.backgroundColor ? this.getAutomaticTextColor(this.invoiceThemeSettings.emitter.style.backgroundColor) : '',
    //             "text-align": "left",
    //         }
    //     }
    //     return ""
    // }
    // get emitterVColStyle() {
    //     if(this.invoiceThemeSettings?.emitter?.style?.textPosition) {
    //         if(this.invoiceThemeSettings.emitter.style.textPosition === "center") {
    //             return "px-2 d-flex justify-center"
    //         }
    //     }
    //     return "px-2 d-flex justify-start"
    // }

    // @Watch('invoiceThemeSettings', {deep: true})
    // tableGeneralStyle() {
    //     if (this.invoiceThemeSettings?.tables) {
    //         return {
    //             "border": this.invoiceThemeSettings?.tables?.rows.border ? "1px" : "0px",
    //             "border-collapse":"collapse",
    //             "width":"100%",
    //         }
    //     }
    // }

    // tableHeaderStyle(row) {

    //     if (this.invoiceThemeSettings?.tables?.header) {
    //         return {
    //             "color": this.invoiceThemeSettings.tables.header.backgroundColor ? this.getAutomaticTextColor(this.invoiceThemeSettings.tables.header.backgroundColor) : '',
    //             "text-align": row?.align ? row.align : "start",
    //             "width": row?.width ? row.width : "15%",
    //             "padding":"10px",
    //             "border-collapse":"collapse",
    //             "border-style": this.invoiceThemeSettings?.tables?.rows.border ? "solid" : "none",
    //             "border-top-width": this.invoiceThemeSettings?.tables?.rows.border ? "1px" : "0px",
    //             "border-left-width": this.invoiceThemeSettings?.tables?.rows.border ? "1px" : "0px",
    //             "border-right-width": this.invoiceThemeSettings?.tables?.rows.border ? "1px" : "0px",
    //             "border-bottom-width": this.invoiceThemeSettings?.tables?.rows.border ? "1px" : "0px",
    //             "border-color": this.invoiceThemeSettings?.tables?.rows?.borderColor ? this.invoiceThemeSettings.tables.rows.borderColor : "black",
    //             "background-color": this.invoiceThemeSettings?.tables?.header?.backgroundColor ? this.invoiceThemeSettings.tables.header.backgroundColor : "",
    //             "font-weight": this.invoiceThemeSettings?.tables?.header?.fontWeight ? this.invoiceThemeSettings.tables.header.fontWeight : "",

    //         }
    //     }
    // }

    // tableRowsStyle(row) {

    //     if (this.invoiceThemeSettings?.tables?.rows) {
    //         return {
    //             "color": this.invoiceThemeSettings?.tables?.rows?.backgroundColor ? this.getAutomaticTextColor(this.invoiceThemeSettings.tables.rows.backgroundColor) : '',
    //             "text-align": row.includes('Produit') ? 'start' : row.includes('120') ? 'end' : 'center',
    //             "padding": '5px',
    //             // "padding-right":"10px",
    //             "border-collapse":"collapse",
    //             "border-style": this.invoiceThemeSettings?.tables?.rows.border ? "solid" : "none",
    //             // "border-bottom-style": "none",
    //             "border-top-width": this.invoiceThemeSettings?.tables?.rows?.border ? "1px" : "0px",
    //             "border-left-width": this.invoiceThemeSettings?.tables?.rows?.border ? "1px" : "0px",
    //             "border-right-width": this.invoiceThemeSettings?.tables?.rows?.border ? "1px" : "0px",
    //             "border-bottom-width": this.invoiceThemeSettings?.tables?.rows?.border ? "1px" : "0px",
    //             "border-color": this.invoiceThemeSettings?.tables?.rows?.borderColor ? this.invoiceThemeSettings.tables.rows.borderColor : "#efefef",
    //             "background-color": this.invoiceThemeSettings?.tables?.rows?.backgroundColor ? this.invoiceThemeSettings.tables.rows.backgroundColor : "",
    //             "font-weight": this.invoiceThemeSettings?.tables?.rows?.fontWeight ? this.invoiceThemeSettings?.tables?.rows?.fontWeight : "",

    //         }
    //     }
    // }

    // tableFooterStyle() {

    //     if (this.invoiceThemeSettings?.tables?.footer) {
    //         return {
    //             "text-align":'end',
    //             "padding-right":"10px",
    //             "border-collapse":"collapse",
    //             "border-left-style": this.invoiceThemeSettings?.tables?.rows?.border ? "solid" : "none",
    //             "border-right-style": this.invoiceThemeSettings?.tables?.rows?.border ? "solid" : "none",
    //             "border-top-style": this.invoiceThemeSettings?.tables?.rows?.border ? "solid" : "none",
    //             "border-bottom-style": this.invoiceThemeSettings?.tables?.rows?.border ? "solid" : "none",
    //             "border-top-width": this.invoiceThemeSettings?.tables?.footer?.borderTop ? "2px" : "1px",
    //             "border-bottom-width": "1px",
    //             "border-left-width": "1px",
    //             "border-right-width": "1px",
    //             "border-top-color": this.invoiceThemeSettings?.tables?.footer?.totalColorSeparator && this.invoiceThemeSettings?.tables?.footer?.borderTop ? this.invoiceThemeSettings.tables.footer.totalColorSeparator : "#efefef",
    //             "border-left-color": this.invoiceThemeSettings?.tables?.rows?.borderColor ? this.invoiceThemeSettings.tables.rows.borderColor : "#efefef",
    //             "border-right-color": this.invoiceThemeSettings?.tables?.rows?.borderColor ? this.invoiceThemeSettings.tables.rows.borderColor : "#efefef",
    //             "border-bottom-color": this.invoiceThemeSettings?.tables?.rows?.borderColor ? this.invoiceThemeSettings.tables.rows.borderColor : "#efefef",
    //             "font-weight": this.invoiceThemeSettings?.tables?.footer?.fontWeight ? this.invoiceThemeSettings.tables.footer.fontWeight : "",
    //             "background-color": this.invoiceThemeSettings?.tables?.footer?.backgroundColor ? this.invoiceThemeSettings.tables.footer.backgroundColor : "",
    //         }
    //     }
    // }

    back() {
        this.$router.go(-1);
    }

    displayInformations(position) {
        for (const pos in this.invoiceThemeSettings.position) {
            if (
                this.invoiceThemeSettings.position[pos] === position &&
                pos !== "title" &&
                pos !== "pagination"
            ) {
                return this.invoiceTemplate[pos].name;
            }
        }

        return "";
    }

    // toDisplayLogo(position) {

    //     for(const pos in this.invoiceThemeSettings.position) {
    //         if (this.invoiceThemeSettings.position[pos] === position && pos !== 'title') {
    //             if(this.invoiceThemeSettings?.pages[pos]?.logo) {

    //                 this.invoiceThemeSettings.pages[pos].name = false
    //                 return this.invoiceThemeSettings.pages[pos].logo ? this.invoiceThemeSettings.pages[pos].logo : false
    //             }
    //         }
    //     }
    // }
    // get logo() {
    //     return this.company?.logo?.signedUrl
    // }

    get isAccountingUser() {
        // @ts-ignore
        return this.currentUser.isAccountingUser;
    }

    get currentUser(): User {
        console.log("this.$store", this.$store);
        return this.$store?.state.user;
    }

    get clientCompaniesIds() {
        const result = [];
        // @ts-ignore
        for (const company of this.currentUser.allAvailableCompanies) {
            result.push(company.id);
        }
        return result;
    }

    // @Watch("invoiceThemeSettings", {deep: true})
    // themeChange(oldVal, newVal) {
    //     console.log("themeChange", oldVal, newVal)
    // }

    // -----SERVICES------ //  when modified here, also modify in backend
    getAutomaticTextColor(color) {
        //hexadecimal colors
        if (/^#{0,1}[0-9A-F]{6}$/i.test(color)) {
            let i = 0;
            if (color[0] === "#") {
                i++;
            }
            const rgbcolor = {
                r: parseInt(color.substr(i, 2), 16),
                g: parseInt(color.substr(i + 2, 2), 16),
                b: parseInt(color.substr(i + 4, 2), 16),
            };

            const testResult = 0.3 * rgbcolor["r"] + 0.59 * rgbcolor["g"] + 0.11 * rgbcolor["b"];
            if (testResult <= 128) {
                return "white";
            } else {
                return "";
            }
            // const result = ( ( (0.3 * (rgbcolor['r'])) + (0.59 * (rgbcolor['g'])) + (0.11 * (rgbcolor['b'])) ) <= 128) ? '#FFFFFF' : '#000000'
            // return result
        } else {
            debugger;
            return "";
        }
    }

    async onPDFPreview() {
        // const printingHtml = InvoiceHtmlViewService.generateHtmlTemplate({
        //     invoiceThemeSettings: this.invoiceThemeSettings,
        //     company: this.company,
        //     scaleSize: 1,
        //     forPrint: true,
        //     invoiceData: this.invoiceSample,
        //     showBoxShadow: false
        // })

        const htmlService = new InvoiceHtmlViewService(
            true,
            this.invoiceThemeSettings,
            this.invoiceSample,
            null,
            this.company,
            1,
            true,
            this.backgroundImage,
        );
        const printingHtml = htmlService.generateHtmlTemplate();

        if (printingHtml) {
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );

            WinPrint.document.write(printingHtml);

            WinPrint.onload = () => {
                WinPrint.print();
            };

            WinPrint.document.close();
        }
    }

    async handleImageBackground(imageData) {
        if (imageData && imageData.signedUrl) {
            this.backgroundImage = imageData.signedUrl;
        } else {
            debugger;
        }
    }

    async handleAdditionalDocument(docData) {
        if (docData && docData.signedUrl) {
            this.additionalDocument = docData.signedUrl;
        } else {
            debugger;
        }
    }

    handleThemeSelected(settings) {
        if (settings) {
            this.personalisedInvoiceThemeSettings = settings;
            this.handleSettingsChange(settings);
        }
    }

    async handlePersonalizedThemeReset() {
        // this.personalisedInvoiceThemeSettings = JSON.parse(JSON.stringify(this.defaultInvoiceThemeSettings))
        await this.refetchPersonalizedTheme();
    }

    handleDOcumentTypeSelected(value) {
        this.selectedDocumentType = value;
    }
}

export default toNative(InvoiceThemeEdition);
</script>
<style lang="css" scoped>
#previewWrapper {
    box-shadow: 0 0 5px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
</style>
